import React from "react";
import { formatNOK } from "@/lib/format";

interface BudgetSummaryProps {
  budgetTotal: number;
  totalEstCost: number;
  totalHours: number;
  calculatedTotal: number;
  validationDiff: number;
  offerOverheadPct: number;
  offerDiscountPct: number;
  offerDiscountAmount: number;
}

export function BudgetSummary({
  budgetTotal,
  totalEstCost,
  totalHours,
  calculatedTotal,
  validationDiff,
  offerOverheadPct,
  offerDiscountPct,
  offerDiscountAmount,
}: BudgetSummaryProps) {
  return (
    <div className="p-4 rounded-lg bg-muted/50 space-y-1 text-sm">
      <div className="flex justify-between">
        <span className="text-muted-foreground">Budsjettlinjer:</span>
        <strong>{formatNOK(budgetTotal)}</strong>
      </div>
      {offerOverheadPct > 0 && (
        <div className="flex justify-between">
          <span className="text-muted-foreground">+ Overhead ({offerOverheadPct}%):</span>
          <strong>{formatNOK((budgetTotal * offerOverheadPct) / 100)}</strong>
        </div>
      )}
      {offerDiscountPct > 0 && (
        <div className="flex justify-between">
          <span className="text-muted-foreground">- Rabatt ({offerDiscountPct}%):</span>
          <strong className="text-red-600">
            -{formatNOK(
              offerDiscountAmount > 0
                ? offerDiscountAmount
                : (budgetTotal * (1 + offerOverheadPct / 100) * offerDiscountPct) / 100
            )}
          </strong>
        </div>
      )}
      <div className="flex justify-between border-t pt-1 mt-1">
        <span className="text-muted-foreground">Tilbudssum:</span>
        <strong>{formatNOK(calculatedTotal)}</strong>
      </div>
      <div className="flex justify-between">
        <span className="text-muted-foreground">Timer totalt:</span>
        <strong>{totalHours}t</strong>
      </div>
      <div className="flex justify-between">
        <span className="text-muted-foreground">Est. ekst. kost totalt:</span>
        <strong>{formatNOK(totalEstCost)}</strong>
      </div>
      <div className="flex justify-between">
        <span className="text-muted-foreground">Estimert GEEK:</span>
        <strong className="text-green-600">
          {formatNOK(calculatedTotal - totalEstCost)} (
          {calculatedTotal > 0 ? Math.round(((calculatedTotal - totalEstCost) / calculatedTotal) * 100) : 0}
          %)
        </strong>
      </div>
      {validationDiff > 1 && (
        <div className="mt-2 p-2 rounded bg-amber-50 border border-amber-200 text-amber-800 text-xs">
          Avvik mellom tilbudssum og beregnet sum: {formatNOK(validationDiff)}. Sjekk at alle budsjettlinjer er med.
        </div>
      )}
    </div>
  );
}
